import { AgentApiRequestHelper } from '../agent-api-request-helper';
import { DOCUMENT_READER_SENT_BATCH_READ_LIMIT } from './constants';
import type {
  IDocumentReaderUploadBatchResponse,
  IDocumentReaderUploadFile,
} from './types';

/** The files of a sent data room, read batch by batch until `fileCount` are in hand, so a room built
 * from several drops shows every file. Throws on a failed read, for SWR. */
export async function readDocumentReaderUploadFiles(
  uploadId: string,
  fileCount: number
): Promise<IDocumentReaderUploadFile[]> {
  const readBatch = (batchIndex: number) =>
    AgentApiRequestHelper.read<IDocumentReaderUploadBatchResponse>(
      `agent-platform/document-reader/uploads/${encodeURIComponent(uploadId)}?batch=${batchIndex}`
    );
  const first = await readBatch(0);
  const batchCount = Math.min(
    first.upload.batchCount,
    DOCUMENT_READER_SENT_BATCH_READ_LIMIT
  );
  const laterBatchIndexes = Array.from(
    { length: Math.max(batchCount - 1, 0) },
    (_, index) => index + 1
  );
  return laterBatchIndexes.reduce(async (previous, batchIndex) => {
    const files = await previous;
    if (files.length >= fileCount) return files;
    const batch = await readBatch(batchIndex);
    return [...files, ...batch.upload.files];
  }, Promise.resolve(first.upload.files));
}
